import React, { useEffect, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import { Button, Container, Grid, Menu, MenuItem, Snackbar, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import AddWordDialog from './AddWordDialog';
import WordCard from './WordCard';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import useStyles from './styles';
import { useDispatch, useSelector } from 'react-redux';
import Alert from '@material-ui/lab/Alert';
import ReturnsTestDialog from './ReturnsTestDialog';
import { checkForReturnTests, getUserWordBank } from '../../actions';





const DashBoard = () => {
    const classes = useStyles();
    const theme = useTheme();
    const [isDialogOpen, setDialogOpen] = React.useState(false);
    const [isReturnsDialogOpen, setReturnDialog] = useState(false);
    const isMdOrUp = useMediaQuery(theme.breakpoints.up("md"));
    const user = useSelector((state) => state.auth.user);
    const defaultSnackBarMessage = 'You know all the words in the bank. Congratulations. Write a book or something.';
    const defaultSeverity = 'error';
    const dispatch = useDispatch();
    const returnsToTest = useSelector(state => state.returnsToTest);
    const userWordBank = useSelector(state => state.userWordBank);
    const [incorrectWordBank, setIncorrectWordBank] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);



    const [isSnackBarOpen, toggleSnackBar] = useState(false);
    const [snackBarMessage, setSnackBarMessage] = useState('');
    const [snackBarSeverity, setSnackBarSeverity] = useState('Alert');

    



    useEffect(() => {
        if (returnsToTest === null) {
            dispatch(checkForReturnTests());
        }
        if (returnsToTest?.length > 0) {
            handleReturnsDialogOpen();
        }
        if (returnsToTest?.length === 0) {
            handleReturnClose();
        }

    }, [dispatch, returnsToTest])
    useEffect(() => {
        if (!userWordBank.wordBank) {
            dispatch(getUserWordBank());
        } else {
            setIncorrectWordBank(
                userWordBank.wordBank.filter((wordAss) => {
                    if (wordAss.timesIncorrect > 0) {
                        return wordAss;
                    }
                    return false;
                }));


        }
    }, [dispatch, userWordBank.wordBank])


    const handleSortingMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    }

    const handleSortingMenuClose = (howToSort = '') => {
        const newArr = [...incorrectWordBank];
        switch (howToSort) {
            case '':
                break;
            case 'TimesIncorrectDesc':
                setIncorrectWordBank(newArr.sort((a, b) => b.timesIncorrect - a.timesIncorrect))
                break;
            case 'TimesIncorrectAsc':
                setIncorrectWordBank(newArr.sort((a, b) => a.timesIncorrect - b.timesIncorrect))
                break;
            case 'FarthestIncorrect':
                setIncorrectWordBank(newArr.sort((a, b) => {
                    let dateA = new Date(a?.lastTimeIncorrect);
                    let dateB = new Date(b?.lastTimeIncorrect);
                    if (!dateA && !dateB) return -1;
                    if (!dateA) return 1;
                    if (!dateB) return -1;
                    return dateA - dateB;
                }));
                break;
            case 'TimesIncorrectRising':
                setIncorrectWordBank(newArr.sort((a, b) => (new Date(b?.lastTimeIncorrect)) - new Date(a?.lastTimeIncorrect)));
                break;
            default:
                break;
        }
        setAnchorEl(null);

    }



    const handleDialogOpen = () => {
        setDialogOpen(true);
    };
    const handleReturnsDialogOpen = () => {
        setReturnDialog(true);
    }
    const handleReturnClose = () => {
        setReturnDialog(false);
    }

    const handleClose = () => {
        setDialogOpen(false);
    };
    const handleSnackBarClose = () => {
        toggleSnackBar(false);
    }

    const renderItemsForMdAndUpScreen = (arrayOfWords) => {



        return (
            <Grid container justify='space-around' alignItems="stretch">


                <Grid item className={classes.gridMargin} md={3}  >
                    <WordCard shouldBlur={isReturnsDialogOpen} word={!arrayOfWords[1] ? arrayOfWords[1] : arrayOfWords[1]?.word} handleDialogOpen={handleDialogOpen} handleClose={handleClose} />
                </Grid>
                <Grid item className={classes.gridMargin} md={3}  >
                    <WordCard shouldBlur={isReturnsDialogOpen} isCenterCard word={!arrayOfWords[0] ? arrayOfWords[0] : arrayOfWords[0]?.word} handleDialogOpen={handleDialogOpen} handleClose={handleClose} />
                </Grid>
                <Grid item className={classes.gridMargin} md={3}  >
                    <WordCard shouldBlur={isReturnsDialogOpen} word={!arrayOfWords[2] ? arrayOfWords[2] : arrayOfWords[2]?.word} handleDialogOpen={handleDialogOpen} handleClose={handleClose} />
                </Grid>

            </Grid>
        )
    }

    const renderItemsForSmAndDownScreen = (arrayOfWords) => {


        return (



            <React.Fragment>
                <Grid container justify='center' alignItems='center'>
                    <Grid item className={classes.gridMargin} xs={10} sm={7} >
                        <WordCard shouldBlur={isReturnsDialogOpen} word={!arrayOfWords[0] ? arrayOfWords[0] : arrayOfWords[0].word} handleDialogOpen={handleDialogOpen} handleClose={handleClose} />
                    </Grid>
                </Grid>
                <Grid container justify='center' alignItems='center'>
                    <Grid item className={classes.gridMargin} xs={10} sm={7} >
                        <WordCard shouldBlur={isReturnsDialogOpen} word={!arrayOfWords[1] ? arrayOfWords[1] : arrayOfWords[1].word} handleDialogOpen={handleDialogOpen} handleClose={handleClose} />
                    </Grid>
                </Grid>
                <Grid container justify='center' alignItems='center'>
                    <Grid item className={classes.gridMargin} xs={10} sm={7} >
                        <WordCard shouldBlur={isReturnsDialogOpen} word={!arrayOfWords[2] ? arrayOfWords[2] : arrayOfWords[2].word} handleDialogOpen={handleDialogOpen} handleClose={handleClose} />
                    </Grid>
                </Grid>
            </React.Fragment >




        )
    }


    const renderIncorrectItems = () => {
        if (incorrectWordBank?.length === 0 || incorrectWordBank === null) {
            return (
                <Grid>
                    <Typography>
                        You have not gotten any words incorrect yet.
                    </Typography>
                </Grid>

            )
        } else {
            return (

                incorrectWordBank.map((wordAss) => {
                    let newDate = new Date(Date.parse(wordAss.lastTimeIncorrect));
                    
                    return (
                        <Grid key={wordAss.word.word} className={classes.cardSpace} item xs={12} sm={8} md={5} >
                            <Typography className={classes.infoText} align='center'>
                                Times gotten incorrect: {wordAss.timesIncorrect}
                            </Typography>
                            {wordAss?.lastTimeIncorrect ?
                                <Typography align="center" className={classes.infoText}>
                                    
                                    Date of incorrect return: {newDate.toLocaleDateString()}
                                </Typography> :
                                null
                            }
                            <WordCard
                                isFrontOfCard={false}
                                shouldBlur={false}
                                word={wordAss.word}
                                handleDialogOpen={false}
                                handleClose={false}
                            />
                        </Grid>
                    )
                })
            )
        }


    }


    return (
        <React.Fragment>
            <Container>
                <Typography className={classes.sectionTitle} variant="h2" gutterBottom align="center" color="textPrimary" >
                    ${user.wordMoney}
                </Typography>
            </Container>



            {isMdOrUp ? renderItemsForMdAndUpScreen(!user ? [] : user.current3) : renderItemsForSmAndDownScreen(!user ? [] : user.current3)}


            <Container>
                <Typography className={classes.sectionTitle} variant="h2" gutterBottom align="center" color="textPrimary" >
                    Past Incorrect
                    </Typography>
            </Container>
            <Container align='center'>
                <Button className={classes.buttonMargin} onClick={handleSortingMenuOpen} size="small" variant='contained' endIcon={<ExpandMoreIcon />}>
                    Sort by
                </Button>
            </Container>

            <Container>
                <Grid container justify="center">
                    {renderIncorrectItems()}
                </Grid>
            </Container>
            <Menu id="sortIncorrect" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleSortingMenuClose}>
                <MenuItem onClick={() => handleSortingMenuClose('TimesIncorrectDesc')}>Times Incorrect Descending</MenuItem>
                <MenuItem onClick={() => handleSortingMenuClose('TimesIncorrectAsc')}>Times Incorrect Ascending</MenuItem>
                <MenuItem onClick={() => handleSortingMenuClose('RecentlyIncorrect')}>Date Incorrect Recent</MenuItem>
                <MenuItem onClick={() => handleSortingMenuClose('FarthestIncorrect')}>Date Incorrect Farthest</MenuItem>
            </Menu>




            <Dialog open={isDialogOpen} onClose={handleClose} fullWidth maxWidth="sm" scroll='body' >
                <AddWordDialog
                    closeFunction={handleClose}
                    openSnackBarInDashBoard={
                        (message = defaultSnackBarMessage, severity = defaultSeverity) => {
                            toggleSnackBar(true);
                            setSnackBarMessage(message);
                            setSnackBarSeverity(severity)
                        }
                    } />
            </Dialog>

            <Dialog open={isReturnsDialogOpen} disableBackdropClick onClose={handleReturnClose} fullWidth maxWidth='sm' scroll='body'>
                <ReturnsTestDialog closeDialog={handleReturnClose} wordData={returnsToTest?.[0]} totalLength={returnsToTest?.length} />
            </Dialog>



            <Snackbar open={isSnackBarOpen} autoHideDuration={6000} onClose={handleSnackBarClose}>
                <Alert onClose={handleSnackBarClose} severity={snackBarSeverity} >
                    {snackBarMessage}

                </Alert>
            </Snackbar>
        </React.Fragment>

    )

}

export default DashBoard;